import { FC } from 'react';

import { withA11yVisuallyHidden } from '@telialt/common-a11y/src/withA11yVisuallyHidden';
import { useTranslations } from '@telialt/common-cms/src/useTranslations';
import { formatCurrency, withParams } from '@telialt/utils/src/helpers';

import { PLAN_CARD_TEST_ID } from '../../constants';
import { PlanCardModel } from '../../model';
import { OldPriceTag } from '../../PlanCard.styles';

type OldPriceProps = { children: string | number } & PlanCardModel.NegativeProp;

const OldPriceTagAccessible = withA11yVisuallyHidden(OldPriceTag);
export const OldPrice: FC<OldPriceProps> = ({ children: oldPrice, isNegative }) => {
    const { t } = useTranslations();
    if (!oldPrice) {
        return null;
    }
    const priceFormatted = typeof oldPrice === 'number' ? formatCurrency(oldPrice) : oldPrice;
    const readablePrice = withParams(t['plans.euro_per_month.old_price.aria_label'], { amount: priceFormatted });

    return (
        <OldPriceTagAccessible
            accessible={readablePrice}
            $negative={isNegative}
            data-test={PLAN_CARD_TEST_ID.OLD_PRICE}
        >
            {priceFormatted} {t['plans.euro_per_month']}
        </OldPriceTagAccessible>
    );
};
